var FcProductInputModule = /** @class */ (function () {
    function FcProductInputModule() {
    }
    return FcProductInputModule;
}());
export { FcProductInputModule };
